export default "__VITE_ASSET__Ch3XLZO9__"